export interface MonetizationModuleItem {
  id: string;
  label: string;
  icon: string;
  color: string;
  desc: string;
  participating: boolean;
  revenueNote?: string;
}

export const defaultMonetizationModules: MonetizationModuleItem[] = [
  {
    id: 'propia',
    label: 'Publicidad Propia',
    icon: 'ri-advertisement-line',
    color: 'bg-emerald-500',
    desc: 'Gestioná y vendé tus propios espacios publicitarios directamente a anunciantes. Vos definís precios, ubicaciones y duraciones. 100% de la ganancia para tu radio.',
    participating: true,
    revenueNote: '100% de la ganancia',
  },
  {
    id: 'rfw',
    label: 'Red Publicitaria RFW',
    icon: 'ri-global-line',
    color: 'bg-amber-500',
    desc: 'Conectate a la red publicitaria de RadioFrecuenciaWeb. RFW gestiona los anunciantes y llena tus espacios vacíos automáticamente. Ideal para monetizar inventario no vendido.',
    participating: true,
    revenueNote: 'Revenue Share RFW',
  },
  {
    id: 'marketplace',
    label: 'Marketplace',
    icon: 'ri-store-2-line',
    color: 'bg-violet-500',
    desc: 'Publicá productos, servicios o contenido exclusivo en el marketplace de RFW. Los oyentes compran directamente desde tu perfil. Comisión del 8% por transacción.',
    participating: false,
    revenueNote: 'Comisión 8% por venta',
  },
  {
    id: 'patrocinios',
    label: 'Patrocinios',
    icon: 'ri-hand-heart-line',
    color: 'bg-rose-500',
    desc: 'Activá el módulo de patrocinios para que marcas y empresas te encuentren. Recibí propuestas de patrocinio para programas, eventos y contenido exclusivo.',
    participating: false,
    revenueNote: 'Propuestas directas',
  },
];